import React from 'react';

// eslint-disable-next-line import/no-unresolved
import { useStaticQuery, graphql, Link } from 'gatsby';
import HomeKnowledgeCard from './HomeKnowledgeCard';
import MultiCarousel from '../Carousels/MultipleCarousel';

const Q = graphql`
  query BlogPosts {
    posts: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        frontmatter: {
          templateKey: { eq: "blog-post" }
          published: { ne: false }
        }
      }
    ) {
      edges {
        node {
          excerpt(pruneLength: 200)
          timeToRead
          fields {
            url: slug
          }
          frontmatter {
            title
            tags
            relatedAuthorObject {
              fields {
                url: slug
              }
              frontmatter {
                profileImageFixed: profileImage {
                  childImageSharp {
                    fixed(
                      width: 100
                      height: 100
                      quality: 100
                      pngCompressionSpeed: 10
                    ) {
                      ...GatsbyImageSharpFixed_withWebp_noBase64
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const HomeKnowledge = ({
  customTitle,
  customSubtitle,
  versionPillar,
  useSpecificPostsByTag,
  useSpecificPostsByUrl,
  setPythonMiddle
}) => {
  const data = useStaticQuery(Q);
  let posts = data.posts.edges.map(({ node }) => node);

  if (useSpecificPostsByTag) {
    posts = posts.filter(singlePost => {
      return singlePost.frontmatter.tags.some(tag =>
        useSpecificPostsByTag.includes(tag)
      );
    });
  }
  if (useSpecificPostsByUrl) {
    posts = posts.filter(singlePost => {
      return useSpecificPostsByUrl.includes(singlePost.fields.url);
    });

    if (setPythonMiddle) {
      const selectedPost = posts.splice(0, 1);
      posts.splice(1, 0, ...selectedPost);
    }
  }

  const responsive = [
    {
      breakpoint: 820,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1
      }
    }
  ];

  return (
    <div className="knowledge-beam main-home-beam">
      <div className="container">
        <div className="main-title link-area">
          <h2 className="tt">{customTitle || 'Knowledge base'}</h2>
          <h4 className="dd">
            {customSubtitle ||
              'Get the latest knowledge on custom software development on our blog.'}
          </h4>
          {versionPillar ? (
            ''
          ) : (
            <Link to="/blog/" className="btn btn-main">
              Read our blog
            </Link>
          )}
        </div>
      </div>

      <div className="container">
        <div className="knowledge-slider">
          <div className="swiper-container swiper-knowledge">
            <MultiCarousel slidesToShow={3} responsive={responsive}>
              {posts.map(post => {
                return (
                  <div
                    className="swiper-wrapper"
                    key={post.id}
                    draggable={false}
                  >
                    <HomeKnowledgeCard post={post} />
                  </div>
                );
              })}
            </MultiCarousel>
            <div className="swiper-pagination sw-pv2" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="mobile-area">
          <Link to="/blog/" className="btn btn-main">
            Read our blog
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeKnowledge;
